module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-1-m.781db0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-1-m.png
// module id = zfYy
// module chunks = 18